import React from 'react';
import ReactDOM from 'react-dom';
import AppRouter from './routers/AppRouter';
import 'normalize.css/normalize.css';
import './styles/styles.scss';

ReactDOM.render(<AppRouter />, document.getElementById('app'));

//  integrate with wordpress
// https://medium.com/@ReactionGears/react-app-inside-a-wordpress-page-or-post-4c7d38181b3d



// WEBPACK FOOTER //
// ./src/app.js